<template>
  <div class="bzbj-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-content">
            <el-form size="small" ref="editForm" :model="editForm" :rules="editRules" label-width="80px">
              <el-form-item label="包标签号" prop="packnum">
                <el-input v-model="editForm.packnum" ref="packnum" style="width: 300px" placeholder="请输入包标签号或扫描包装二维码" maxlength="15" autocomplete="off"></el-input>
                <el-button style="margin-left: 10px" @click="addData" :loading="fullscreenLoading" icon="el-icon-plus">添加包装</el-button>
                <el-button type="primary" @click="subIn" :loading="loading" icon="el-icon-document-add">立即入库</el-button>
              </el-form-item>
              <div style="font-size: 12px;color:#99a9bf;padding-left: 20px">
                <i class="el-icon-warning-outline"></i> 温馨提示：如果使用扫描器扫描没有反应，请<el-button @click="calibration" style="font-size: 12px" type="text">点击这里</el-button>！
              </div>
            </el-form>
            <el-card shadow="never" style="margin-top: 10px">
              <el-table
                size="small"
                stripe
                :data="tableData"
                style="width: 100%">
                <el-table-column label="包标签号" prop="package_num" width="140" show-overflow-tooltip></el-table-column>
                <el-table-column label="包号" prop="xuhao" align="center" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column label="部件数量" prop="total_unit" align="center" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column label="生产单号" prop="product_num" min-width="140" show-overflow-tooltip></el-table-column>
                <el-table-column
                  label="操作"
                  fixed="right"
                  width="100">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="delData(scope.row)" icon="el-icon-delete">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getPackageInfoByCode, packageInStock } from '@/api/erp'

export default {
  name: 'rk',
  computed: {
    user: getUser
  },
  data() {
    return {
      fullscreenLoading: false,
      loading: false,
      tableData: [],
      editForm: {
        packnum: ''
      },
      editRules: {
        packnum: [{ required: true, message: '请输入包标签号', trigger: 'blur' }]
      }
    }
  },
  created() {
    let keycode = ''
    let lastTime = null
    let nextTime = null
    let lastCode = null
    let nextCode = null
    document.onkeydown = function(e) {
      if (window.event) {
        nextCode = e.keyCode // IE
      } else if (e.which) {
        nextCode = e.which // Netscape/Firefox/Opera
      }
      if ((nextCode >= 48 && nextCode <= 57) || (nextCode >= 96 && nextCode <= 105)) {
        // 数字键盘的键码值对应的字符有问题，所以手动调整键码值
        const codes = { '48': 48, '49': 49, '50': 50, '51': 51, '52': 52, '53': 53, '54': 54, '55': 55, '56': 56, '57': 57,
          '96': 48, '97': 49, '98': 50, '99': 51, '100': 52, '101': 53, '102': 54, '103': 55, '104': 56, '105': 57
        }
        nextCode = codes[nextCode]
        nextTime = new Date().getTime()
        if (lastCode === null && lastTime === null) {
          keycode = String.fromCharCode(nextCode)
        } else if (lastCode !== null && lastTime !== null && nextTime - lastTime <= 30) {
          keycode += String.fromCharCode(nextCode)
        } else {
          keycode = ''
          lastCode = null
          lastTime = null
        }
        lastCode = nextCode
        lastTime = nextTime
      } else if (nextCode === 13 && keycode !== '') {
        this.editForm.packnum = keycode
        this.addData()
        keycode = ''
        lastCode = null
        lastTime = null
      } else if (nextCode === 13) {
        this.addData()
      }
    }
  },
  methods: {
    calibration() {
      this.$message({
        message: '初始成功，可以开始扫描啦~',
        type: 'success'
      })
      this.$refs.editForm.clearValidate()
      this.$refs.packnum.focus()
    },
    addData() {
      if (!this.fullscreenLoading) {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            let ishave = false
            for (let d of this.tableData) {
              if (d.package_num === this.editForm.packnum) {
                ishave = true
                break
              }
            }
            if (!ishave) {
              this.fullscreenLoading = true
              getPackageInfoByCode({ code: this.editForm.packnum }).then(response => {
                if (response.data.imark === 0) {
                  let datajson = []
                  datajson.push(response.data)
                  for (let olddata of this.tableData) {
                    datajson.push(olddata)
                  }
                  this.tableData = datajson
                } else {
                  this.$message({
                    message: '包装 “' + response.data.package_num + '” 已入库',
                    type: 'warning'
                  })
                }
                this.fullscreenLoading = false
                this.editForm.packnum = ''
                this.$refs.editForm.clearValidate()
                this.$refs.packnum.focus()
              }).catch(() => {
                this.fullscreenLoading = false
                this.editForm.packnum = ''
                this.$refs.editForm.clearValidate()
                this.$refs.packnum.focus()
              })
            } else {
              this.editForm.packnum = ''
              this.$refs.editForm.clearValidate()
              this.$refs.packnum.focus()
            }
          } else {
            return false
          }
        })
      }
    },
    delData(row) {
      this.$confirm('此操作将删除 “' + row.package_num + '” 包装, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (let i = 0; i < this.tableData.length; i++) {
          if (row.package_id === this.tableData[i].package_id) {
            this.tableData.splice(i, 1)
            break
          }
        }
        this.$message({
          type: 'success',
          message: '删除成功'
        })
        this.$refs.editForm.clearValidate()
        this.$refs.packnum.focus()
      }).catch(() => {
        this.$refs.editForm.clearValidate()
        this.$refs.packnum.focus()
      })
    },
    subIn() {
      if (!this.loading) {
        if (this.tableData.length > 0) {
          this.$confirm('确认入库此 ' + this.tableData.length + ' 项包装, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let unitIds = []
            for (let m of this.tableData) {
              unitIds.push(m.package_id)
            }
            this.loading = true
            const data = {
              userid: this.user.dUserid,
              packageIds: unitIds.join(',')
            }
            packageInStock(data).then(response => {
              this.tableData = []
              this.loading = false
              this.$message({
                message: '入库成功',
                type: 'success'
              })
              this.$refs.editForm.clearValidate()
              this.$refs.packnum.focus()
            }).catch(() => {
              this.loading = false
            })
          }).catch(() => {
            this.$refs.editForm.clearValidate()
            this.$refs.packnum.focus()
          })
        } else {
          this.$message.error('至少入库一个包装')
          this.$refs.editForm.clearValidate()
          this.$refs.packnum.focus()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rk-container {

}
</style>
